import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/** Whether the Portal Chat slide-out panel is open (toggled from the header Chats icon). */
const showPortalChatSlice = createSlice({
  name: "showPortalChat",
  initialState: false,
  reducers: {
    setShowPortalChat: (_state: boolean, action: PayloadAction<boolean>) => action.payload,
  },
});

/** Unread-conversation count for the header Chats badge (muted conversations excluded). */
const portalChatUnreadCountSlice = createSlice({
  name: "portalChatUnreadCount",
  initialState: 0,
  reducers: {
    setPortalChatUnreadCount: (_state: number, action: PayloadAction<number>) => action.payload,
  },
});

export const { setShowPortalChat } = showPortalChatSlice.actions;
export const { setPortalChatUnreadCount } = portalChatUnreadCountSlice.actions;

export const showPortalChat = showPortalChatSlice.reducer;
export const portalChatUnreadCount = portalChatUnreadCountSlice.reducer;
